import { render, staticRenderFns } from "./local.vue?vue&type=template&id=62adb2be&scoped=true"
import script from "./local.vue?vue&type=script&lang=js"
export * from "./local.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62adb2be",
  null
  
)

export default component.exports